import createSagaMiddleware from '@redux-saga/core';
import { configureStore } from '@reduxjs/toolkit';
import {
    genericBladeReducer as genericBlade,
    getGenericBladePreloadState,
    loanPurposeReducer as loanPurpose,
} from '@commblades/commblades';

import netBank from '../app/netBank/netBankSlice';
import navigation from '../app/navigation/navigationSlice';
import rootSaga from './rootSaga';
import applicationStartState from '../app/navigation/blades/applicationStart/applicationStartState';
import errorState from '../app/navigation/blades/error/errorState';
import loanPurposesState from '../app/navigation/blades/loanPurposes/loanPurposesStates';
import subLoanPurposeState from '../app/navigation/blades/subLoanPurpose/subLoanPurposeState';
import { yourFinanceReducer as yourFinance } from '../app/navigation/blades/yourFinance/yourFinanceSlice';
import { initialStateYourFinance as yourFinanceState } from '../app/navigation/blades/yourFinance/yourFinanceStates';
import { borrowingPowerReducer as borrowingPower } from '../app/navigation/blades/borrowingPower/borrowingPowerSlice';
import { initialStateBorrowingPower as borrowingPowerState } from '../app/navigation/blades/borrowingPower/borrowingPowerStates';
import spinner from '../components/Spinner/spinnerSlice';

const sagaMiddleware = createSagaMiddleware();

export const reducers = {
    netBank,
    navigation,
    genericBlade,
    yourFinance,
    borrowingPower,
    loanPurpose,
    spinner,
};

export const genericBladeStates = getGenericBladePreloadState(
    [
        applicationStartState,
        subLoanPurposeState,
        errorState,
    ],
);

const preloadedState = {
    genericBlade: genericBladeStates,
    loanPurpose: loanPurposesState,
    yourFinance: yourFinanceState,
    borrowingPower: borrowingPowerState,
};

export const store = configureStore({
    reducer: reducers,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ thunk: false }).concat(sagaMiddleware),
    preloadedState,
    devTools: true,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

sagaMiddleware.run(rootSaga);
